export var getHrefMailToString = function getHrefMailToString(emailAddress) {
  return "mailto:".concat(emailAddress);
};